import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { AsyncPaginate } from "react-select-async-paginate";
import { ForeignData_API } from "../../../APIs/ForeignData.api";
import Swal from "sweetalert2";
import moment from "moment";
import { be } from "date-fns/locale";

const RHFInput = ({
  control,
  name,
  label,
  type = "text",
  readOnly = false,
  defaultValue = "",
}) => (
  <div className="mb-3 row">
    <label className="col-sm-3 col-form-label">{label}</label>
    <div className="col-sm-9">
      <Controller
        control={control}
        name={name}
        // defaultValue={defaultValue}
        render={({ field }) => (
          <input
            {...field}
            className="form-control"
            type={type}
            readOnly={readOnly}
          />
        )}
      />
    </div>
  </div>
);

export default function ShipModal({
  id = "ShipModal",
  lang,
  proxy,
  token,
  item,
  onDone,
  setData,
}) {
  const [loading, setLoading] = useState(true);
  const {
    shipHang: {
      ngayxuat,
      ngaydangky,
      ngaygiaygioithieu,
      noicap,
      cmnd,
      donvivanchuyen,
      donvinhanhang,
      giayuyquyen,
      xuathangkhotau,
      biensoxetau,
      tenphuongtien,
    } = {},
    ngayXuat: nx,
    bsXeGhe,
    phuongTien,
  } = item || {};

  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      ships: [],
    },
  });

  const _token = localStorage.getItem("_token");

  const { fields, replace } = useFieldArray({
    control,
    name: "ships",
    keyName: "keyId",
  });

  useEffect(() => {
    const load = async () => {
      if (!item?.dataShips) {
        reset({ ships: [] });
        setLoading(false);
        return;
      }

      const formatDateTime = (date) =>
        date ? moment(date).utc().format("YYYY-MM-DDTHH:mm") : "";

      const formatDate = (date) =>
        date ? moment(date).utc().format("YYYY-MM-DD") : "";

      reset({
        ships: [
          {
            ...item.dataShips,
            ngayxuat: ngayxuat
              ? formatDateTime(ngayxuat || "")
              : formatDateTime(nx || ""),
            ngaydangky: formatDate(ngaydangky || ""),
            ngaygiaygioithieu: formatDate(ngaygiaygioithieu),
            noicap: noicap || "",
            cmnd: cmnd || "",
            donvivanchuyen: donvivanchuyen || "",
            donvinhanhang: donvinhanhang || "",
            giayuyquyen: giayuyquyen || "",
            xuathangkhotau: xuathangkhotau || "",
            biensoxetau: biensoxetau || bsXeGhe || "",
            tenphuongtien: tenphuongtien || phuongTien || "",
          },
        ],
      });

      setLoading(false);
    };

    load();
  }, [item, reset]);

  const onSubmit = async ({ ships }) => {
    const find = ships.find(
      ({ phieuxuatkhosaas }) => phieuxuatkhosaas === item?.["10MPXK"]
    );

    setData((prev) =>
      prev.map((data) => {
        if (data?.dataShips?._id === find._id) {
          return {
            ...data,
            dataShips: {
              ...data.dataShips,
              ...find,
            },
          };
        }
        return data;
      })
    );
    const dataUpdate = {
      ngayxuat: find?.ngayxuat,
      ngaydangky: find?.ngaydangky,
      ngaygiaygioithieu: find?.ngaygiaygioithieu,
      noicap: find?.noicap,
      cmnd: find?.cmnd,
      donvivanchuyen: {
        label: find?.donvivanchuyen?.label,
        value: find?.donvivanchuyen?.value,
      },
      donvinhanhang: {
        label: find?.donvinhanhang?.label,
        value: find?.donvinhanhang?.value,
      },
      giayuyquyen: find?.giayuyquyen,
      xuathangkhotau: find?.xuathangkhotau,
    };

    fetch(`${proxy()}/api/PXK/ShipConfirmPhieuXuatKho`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: _token,
      },
      body: JSON.stringify({
        phieuxuatkhosaas: find?.phieuxuatkhosaas,
        maphieuxuatkho: find?.maphieuxuatkho,
        data: dataUpdate,
      }),
    })
      .then((res) => res.json())
      .then((resp) => {
        const { success, message } = resp;
        if (success) {
          onDone();
        }
        Swal.fire({
          icon: success ? "success" : "error",
          title: success ? "Thành công" : "Lỗi",
          text:
            message ||
            (success
              ? "Cập nhật thông tin mở rộng thành công."
              : "Cập nhật thông tin mở rộng thất bại."),
        });
      });
  };
  // useEffect(() => {
  //   const fetchData = async () => {
  //     fetch(`${proxy()}/api/foreign/data`)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         console.log("Fetched shipment details:", data);
  //       });
  //   };

  //   fetchData();
  // }, []);

  const loadOptions = async (
    page = 0,
    search = "",
    displayFields,
    table_id,
    proxy,
    isPK
  ) => {
    return new Promise(async (resolve, reject) => {
      let dataBody = {
        table_id,
        start_index: page,
        type: "or",
      };

      let newData = {
        options: [],
        hasMore: false,
        additional: {
          page: 0,
        },
      };
      if (search) {
        let criteria = {};
        let criteria_type = {};
        displayFields.forEach((field) => {
          criteria[field] = search.trim();
          criteria_type[field] = "regex";
        });

        dataBody.criteria = criteria;
        dataBody.criteria_type = criteria_type;
      }

      const _token = localStorage.getItem("_token");
      try {
        const { data } = await ForeignData_API.get(proxy(), _token, dataBody);
        let hasMoreValue = true;

        if (!data?.length) {
          hasMoreValue = false;
        }

        if (data.length) {
          const options = data.flatMap((item) => {
            const hasArrayField = displayFields.find((field) =>
              Array.isArray(item[field])
            );

            if (!hasArrayField) {
              return item?.[isPK]
                ? [
                    {
                      label: displayFields
                        .map((field) => item[field])
                        .filter(Boolean)
                        .join("|"),
                      value: item?.[isPK],
                      ...item,
                    },
                  ]
                : [];
            }

            const arrayField = hasArrayField;
            const arrayValues = item[arrayField];

            return [
              {
                label: displayFields
                  .map((field) => item[field])
                  .filter(Boolean)
                  .join("|"),
                value: item?.[isPK],
                ...item,
              },
            ];
          });

          newData = {
            options,
            hasMore: hasMoreValue,
            additional: {
              page: hasMoreValue ? page + 15 : page,
            },
          };
        }

        setTimeout(() => {
          resolve(newData);
        }, 100);
      } catch (error) {
        console.error("Error in loadOptions:", error);
        reject(error);
      }
    });
  };

  return (
    <div className="modal fade" id={id}>
      <div className="modal-dialog" style={{ maxWidth: "80%" }}>
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h5
              className="w-100"
              style={{ color: "#44a1a1", fontSize: 18, padding: "6px 0" }}
            >
              Thông tin mở rộng
            </h5>
          </div>

          <div className="modal-body">
            <div className="container-fluid">
              {loading ? (
                <div className="w-100 text-center">
                  <img
                    width={40}
                    src="/images/icon/load.gif"
                    alt="Loading..."
                  />
                </div>
              ) : (
                fields.map((f, index) => (
                  <div
                    className="input row mb-4 border-bottom pb-3"
                    key={f.keyId}
                  >
                    <div className="col-sm-6">
                      <RHFInput
                        control={control}
                        name={`ships.${index}.ngayxuat`}
                        label="Ngày xuất"
                        type="datetime-local"
                        defaultValue={ngayxuat}
                      />
                      <RHFInput
                        control={control}
                        name={`ships.${index}.xuathangkhotau`}
                        label="Xuất hàng cho tàu"
                        defaultValue={xuathangkhotau}
                      />
                      <RHFInput
                        control={control}
                        name={`ships.${index}.nguoinhan`}
                        label="Người nhận hàng"
                        defaultValue={item?.nguoiNhan}
                        readOnly
                      />
                      <RHFInput
                        control={control}
                        name={`ships.${index}.biensoxetau`}
                        label="Biển số phương tiện"
                        defaultValue={item?.bsXeGhe}
                        readOnly
                      />
                      <RHFInput
                        control={control}
                        name={`ships.${index}.giayuyquyen`}
                        label="Giấy GT/Ủy quyền"
                        defaultValue={giayuyquyen}
                      />
                      {/* <RHFInput
                        control={control}
                        name={`ships.${index}.donvivanchuyen`}
                        label="Đơn vị vận chuyển"
                      /> */}
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">
                          Đơn vị vận chuyển
                        </label>
                        <div className="col-sm-9">
                          <Controller
                            control={control}
                            name={`ships.${index}.donvivanchuyen`}
                            render={({ field }) => (
                              <AsyncPaginate
                                value={field.value}
                                onChange={field.onChange}
                                loadOptions={async (
                                  search,
                                  loadedOptions,
                                  { page }
                                ) => {
                                  return await loadOptions(
                                    page,
                                    search,
                                    ["madonvivanchuyen", "tendonvivanchuyen"],
                                    5263154,
                                    proxy,
                                    "tendonvivanchuyen"
                                  );
                                }}
                                additional={{ page: 0 }}
                                isSearchable
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                placeholder={lang["select value"]}
                                noOptionsMessage={() => (
                                  <div style={{ fontWeight: 300 }}>
                                    {lang["not found data"]}
                                  </div>
                                )}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      {/* <RHFInput
                        control={control}
                        name={`ships.${index}.donvinhanhang`}
                        label="Đơn vị NH/Vận chuyển"
                      /> */}
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">
                          Đơn vị NH/Vận chuyển
                        </label>
                        <div className="col-sm-9">
                          <Controller
                            control={control}
                            name={`ships.${index}.donvinhanhang`}
                            render={({ field }) => (
                              <AsyncPaginate
                                value={field.value}
                                onChange={field.onChange}
                                loadOptions={async (
                                  search,
                                  loadedOptions,
                                  { page }
                                ) => {
                                  return await loadOptions(
                                    page,
                                    search,
                                    ["madonvivanchuyen", "tendonvivanchuyen"],
                                    5263154,
                                    proxy,
                                    "tendonvivanchuyen"
                                  );
                                }}
                                additional={{ page: 0 }}
                                isSearchable
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                placeholder={lang["select value"]}
                                noOptionsMessage={() => (
                                  <div style={{ fontWeight: 300 }}>
                                    {lang["not found data"]}
                                  </div>
                                )}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                      <RHFInput
                        control={control}
                        name={`ships.${index}.cmnd`}
                        label="CMND"
                      />
                      <RHFInput
                        control={control}
                        name={`ships.${index}.tenphuongtien`}
                        label="Phương tiện nhận hàng"
                        defaultValue={tenphuongtien}
                        readOnly
                      />
                      <RHFInput
                        control={control}
                        name={`ships.${index}.noicap`}
                        label="Nơi cấp"
                      />
                      <RHFInput
                        control={control}
                        name={`ships.${index}.ngaygiaygioithieu`}
                        label="Ngày giấy giới thiệu"
                        type="date"
                      />
                      <RHFInput
                        control={control}
                        name={`ships.${index}.ngaydangky`}
                        label="Ngày đăng ký"
                        type="date"
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit(onSubmit)}
              disabled={isSubmitting || !fields.length}
              // data-dismiss="modal"
            >
              {lang["btn.update"]}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              {lang["btn.close"]}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
